import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Clock, X } from "lucide-react";
import { usePremium } from "@/context/PremiumContext";

// In-app reminder shown to subscribers during the last 3 days of their 7-day
// free trial, so they aren't surprised by the first charge. Dismissible per day.
export function TrialEndingBanner() {
  const { user } = usePremium() || {};
  const [hidden, setHidden] = useState(false);

  const trialEndStr = user && user.trial_end;

  useEffect(() => {
    if (!trialEndStr) return;
    const dayKey = `vspo_trial_end_dismissed_${new Date().toISOString().slice(0, 10)}`;
    try {
      setHidden(localStorage.getItem(dayKey) === "1");
    } catch {
      setHidden(false);
    }
  }, [trialEndStr]);

  if (!trialEndStr) return null;
  const end = new Date(trialEndStr);
  const msLeft = end.getTime() - Date.now();
  const daysLeft = Math.ceil(msLeft / 86400000);
  if (hidden || msLeft <= 0 || daysLeft > 3) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(`vspo_trial_end_dismissed_${new Date().toISOString().slice(0, 10)}`, "1");
    } catch (e) {
      console.debug("[trial-ending] dismiss failed:", e);
    }
    setHidden(true);
  };

  const whenTxt = daysLeft <= 1 ? "aujourd'hui" : `dans ${daysLeft} jours`;

  return (
    <div
      className="flex items-center gap-2 border-b border-amber-500/40 bg-amber-500/10 px-3 py-1.5 text-xs text-amber-800 dark:text-amber-200"
      data-testid="trial-ending-banner"
    >
      <Clock className="h-4 w-4 shrink-0 text-amber-500" />
      <span className="flex-1 leading-tight">
        Votre essai gratuit se termine <strong>{whenTxt}</strong>, puis 0,99 €/mois.{" "}
        <Link to="/compte" className="font-semibold underline" data-testid="trial-ending-manage">
          Gérer mon abonnement
        </Link>
      </span>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Masquer"
        data-testid="trial-ending-close"
        className="shrink-0 rounded-md p-0.5 hover:bg-amber-500/20"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
